import { render, staticRenderFns } from "./AdditionsTable.vue?vue&type=template&id=493e9554&"
import script from "./AdditionsTable.vue?vue&type=script&lang=ts&"
export * from "./AdditionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports